import { Component, Input } from '@angular/core';
import { Store } from 'src/app/core/stores.service';

@Component({
  selector: 'app-home-stores-item',
  templateUrl: './home-stores-item.component.html',
  styleUrls: ['./home-stores-item.component.scss'],
})
export class HomeStoresItemComponent {
  @Input() store?: Store;
}
